export enum RoutePath {
    BACKOFFICE = 'backoffice',
    RATES = 'tasas',
    DETAIL = 'detalle',
    EDIT = 'editar',
    CREATE = 'crear',
    LOGIN = 'login',
    USERS = 'usuarios',
    ORDERS = 'ordenes',
    PROFILES = 'perfiles',
    CONCILIATIONS = 'conciliaciones',
    CONFIGURATION_KYES = 'configuracion-llaves',
    FORGOT_PASSWORD = 'forgot-password',
    BULK_LOAD = 'cargas-masivas',
}
